<template>
  <div class="container-narrow mx-auto mt-20">
    <h1 class="md:pt-12">{{ msg }}</h1>
    <p class="text-lg mt-8">
      At First Options Fertility we specialise in male fertility testing. Our clinic is dedicated to male fertility investigations and we strive to provide the most comprehensive suite of tests available all with the aim of informing our clients of the status of their fertility. In a straightforward non-invasive process we analyse your semen and guide you on your first steps to taking control of your fertility.
    </p>
    <p class="text-lg mt-4">
      First Options Fertility is located in Gorey, Co. Wexford servicing clients all over Ireland in a discreet and professional manner. Tests available in First Options Fertility include standard semen assessment, semen oxidative stress testing, DNA integrity testing also known as DNA fragmentation testing and semen culture and sensitivity testing.
    </p>

    <AppButton class="mt-12 primary"
      link="https://calendly.com/firstoptionsfertility"
      msg="Make an Appointment"
      target="_blank"
    />
    <AppButton class="mt-12 ml-2 tertiary" link="#why-us" msg="Learn more" />
  </div>
</template>

<script>
import AppButton from './ui/AppButton.vue'

export default {
  name: 'SiteHero',
  components: {
    AppButton
  },
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
